module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley"
  }, [_vm._m(0), _c('a', {
    attrs: {
      "id": "page_normal--num_xvii--seq_17"
    }
  }, [_c('div', {
    staticClass: "block image",
    attrs: {
      "id": "block_image--num_--seq_1"
    }
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "viewbox": "0 0 400 673",
      "width": "100%",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('rect', {
    attrs: {
      "fill": "#ffffff",
      "height": "673",
      "width": "400",
      "x": "0",
      "y": "0"
    }
  }), _c('image', {
    attrs: {
      "height": "673",
      "transform": "translate(0 0)",
      "width": "400",
      "xlink:href": "a41953749_003.png"
    }
  })])])]), _vm._m(1), _c('a', {
    attrs: {
      "id": "page_normal--num_2--seq_19"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_normal--num_2--seq_19"
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "id": "page_normal--num_xvii--seq_17"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "id": "page_normal--num_xvii--seq_17"
    }
  }), _c('a', {
    attrs: {
      "id": "page_normal--num_1--seq_18"
    }
  }), _c('a', {
    attrs: {
      "id": "page_normal--num_2--seq_19"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09cdc060","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/a9781847673749_part_01.vue
// module id = 81
// module chunks = 0